import React, { useEffect } from 'react';

import { LazyImage } from "components/Image/Index";

import classNames from 'classnames';
import * as fromProjects from 'store/Projects';

import { a } from '@react-spring/web';
import { useIntersect } from 'hooks/useIntersect';
import { useAnimateInSpring } from 'hooks/useAnimateInSpring';
import { initialOffset } from 'components/Animations/SpringProperties/SpringProperties';

interface IProps {
  animationReady: boolean;
  bodyContent: object;
  previousSameComponent: boolean;
  alignRight: boolean;
  addContentBlockSpacer(element: JSX.Element): any;
  makeSectionTitleSticky(): any;
  addExtraTopPaddingToBlock(): any;
}

export const StickyScrollingImage: React.FC<IProps> = ({ animationReady, previousSameComponent, alignRight, addExtraTopPaddingToBlock, addContentBlockSpacer, makeSectionTitleSticky, ...props }) => {
  const bodyContent: fromProjects.IContentStickyScrollingImageSection = props.bodyContent as fromProjects.IContentStickyScrollingImageSection;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const animateInSpring = useAnimateInSpring(inView);

  useEffect(() => {
    makeSectionTitleSticky();

    addContentBlockSpacer((
      <div className='stickyScrollingContentSpacerWrapper'>
        <div className='spacer-image'>
          <img
            src=''
            alt='section height placeholder'
            style={{
              paddingBottom: (bodyContent.image.heightRatio * 100) + '%',
            }}
          />
        </div>
      </div>
    ));

    if (previousSameComponent)
      addExtraTopPaddingToBlock();
  }, []);

  const imageWrapperStyles = {
    opacity: animateInSpring.active,
    transform: animateInSpring.active.to(x => `translateY(calc(${initialOffset(x)}))`),
  };

  return (
    <div
      ref={inViewRef}
      className={classNames(
        'stickyScrollingImageWrapper',
        { alignRight },
      )}
    >
      <a.div style={imageWrapperStyles}>
        <LazyImage
          heightRatio={bodyContent.image.heightRatio}
          src={'/assets/images/work/' + bodyContent.image.url}
          alt={bodyContent.image.alt}
          animateImageIn={true}
          animationType={'fadeIn'}
        />
      </a.div>
    </div>
  );
};
